export const SYMBOL_SVG =
  "<svg width='16' height='16' viewBox='0 0 16 16' fill='inherit' xmlns='http://www.w3.org/2000/svg'><g><circle opacity='0.25' cx='8' cy='8' r='8' fill='inherit'/><circle cx='8' cy='8' r='3.5' fill='inherit' stroke='white'/></g></svg>";

// Encode svg to data URI and supports color
export function encodeSvgToDataURI(svg: string, color: string) {
  return `image://data:image/svg+xml;charset=utf8,${encodeURIComponent(svg.replace("inherit", color))}`;
}
